import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-689330fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "popup-project-rv-success"
}
const _hoisted_2 = { class: "popup-project-rv-success-fixed" }
const _hoisted_3 = { class: "popup-820" }
const _hoisted_4 = { class: "right-popup-rv" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-w-back font-tiempos duan-tl" }, " Đăng ký nhận email tin tức từ Academy ", -1))
const _hoisted_6 = { class: "content-pu-rv" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "res-success" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/static/images/icon-success.svg",
      alt: "",
      title: "",
      style: {"filter":"invert(59%) sepia(48%) saturate(548%) hue-rotate(73deg) brightness(90%) contrast(86%)"}
    })
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "font-tiempos" }, "Đăng ký thành công!")
], -1))
const _hoisted_8 = { class: "or-direct-call" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "action btn-success-popup" }
const _hoisted_11 = {
  key: 1,
  class: "popup-project-rv-success"
}
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"popup-project-rv-success-fixed\" data-v-689330fa><div class=\"popup-820\" data-v-689330fa><div class=\"right-popup-rv\" data-v-689330fa><div class=\"title-w-back font-tiempos duan-tl\" data-v-689330fa> Đăng ký nhận email tin tức từ Academy </div><div class=\"content-pu-rv\" data-v-689330fa><div class=\"res-success\" data-v-689330fa><p class=\"\" style=\"margin-bottom:20px;\" data-v-689330fa></p><p class=\"font-tiempos\" data-v-689330fa>Đang gửi thông tin đăng ký...!</p></div></div></div></div></div>", 1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 2,
  ref: "bgOverlay",
  class: "bg-overlay"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popup-title-w-back" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Đăng ký nhận tin tức từ Academy")
], -1))
const _hoisted_16 = { class: "form" }
const _hoisted_17 = { class: "tab-content" }
const _hoisted_18 = { id: "signin" }
const _hoisted_19 = { class: "field-wrap" }
const _hoisted_20 = { class: "field-wrap" }
const _hoisted_21 = { class: "field-wrap" }
const _hoisted_22 = {
  key: 0,
  class: "error-message"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "zmdi zmdi-alert-circle-o" }, null, -1))
const _hoisted_24 = {
  class: "button-groups",
  style: {"padding-top":"10px"}
}
const _hoisted_25 = ["disabled"]
const _hoisted_26 = {
  key: 0,
  class: "zmdi zmdi-spinner zmdi-hc-spin"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "zmdi zmdi-close" }, null, -1))
const _hoisted_28 = [
  _hoisted_27
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.submitted)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("p", null, [
                    _createTextVNode("Cảm ơn bạn đã quan tâm và đăng ký nhận các thông tin từ Rever Academy. Chúng tôi sẽ thường xuyên cập nhật thông tin qua email bạn đã đăng ký. Nếu có thắc mắc cần giải đáp ngay, vui lòng liên hệ email "),
                    _createElementVNode("a", {
                      href: `mailto:${_ctx.academyEmail}`
                    }, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.academyEmail), 1)
                    ], 8, _hoisted_9),
                    _createTextVNode(" để được tư vấn trực tiếp. Trân trọng! ")
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("a", {
                    class: "large-btn-red",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)), ["prevent"])),
                    href: "#"
                  }, "Đóng")
                ])
              ])
            ])
          ])
        ])
      ]))
    : (_ctx.submitting)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
      : (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", {
            class: _normalizeClass(["popup", {'animationClose': _ctx.submitted, 'animationOpen': !_ctx.submitted || _ctx.submitting}])
          }, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("form", {
                    action: "/",
                    onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("div", _hoisted_19, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.firstname) = $event)),
                        name: "firstname",
                        type: "text",
                        placeholder: "Họ*"
                      }, null, 512), [
                        [_vModelText, _ctx.formData.firstname]
                      ]),
                      _createElementVNode("p", {
                        class: _normalizeClass(["error", {'active': _ctx.v$.formData?.firstname.$error}])
                      }, "Họ không hợp lệ", 2)
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.lastname) = $event)),
                        name: "lastname",
                        type: "text",
                        placeholder: "Tên*"
                      }, null, 512), [
                        [_vModelText, _ctx.formData.lastname]
                      ]),
                      _createElementVNode("p", {
                        class: _normalizeClass(["error", {'active': _ctx.v$.formData?.lastname.$error}])
                      }, "Tên không hợp lệ", 2)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.email) = $event)),
                        name: "email",
                        type: "email",
                        placeholder: "Email*"
                      }, null, 512), [
                        [_vModelText, _ctx.formData.email]
                      ]),
                      _createElementVNode("p", {
                        class: _normalizeClass(["error", {'active': _ctx.v$.formData?.email.$error}])
                      }, "Email không hợp lệ", 2)
                    ]),
                    (_ctx.error)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _createElementVNode("div", null, [
                            _hoisted_23,
                            _createTextVNode(" " + _toDisplayString(_ctx.error.message), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("button", {
                        disabled: _ctx.submitting,
                        type: "submit",
                        class: "btn-primary btn-large btn-red"
                      }, [
                        _createElementVNode("span", null, [
                          (_ctx.submitting)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_26))
                            : _createCommentVNode("", true),
                          _createTextVNode(" Đăng ký ")
                        ])
                      ], 8, _hoisted_25)
                    ])
                  ], 32)
                ])
              ]),
              _createElementVNode("a", {
                onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)), ["prevent"])),
                class: "closeBtn",
                href: "#"
              }, _hoisted_28)
            ])
          ], 2)
        ], 512))
}